import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { QuoteCartPageInitialData } from "./quoteCartPageInitialData";

export const quoteCartPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.quote(),
    queryFn: () => fetchOccPageData<PageInitialDataResult<QuoteCartPageInitialData>>("/page-data/quote"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
